import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setDevice } from './../actions';
import PropTypes from 'prop-types';

import AcquisitionMetricsSelectorComponent
  from './../Components/AcquisitionMetricsSelectorComponent.jsx';
import AcquisitionLineChartComponent
  from './../Components/AcquisitionLineChartComponent.jsx';

import { getDeviceName } from './../reducers';

export class AcquisitionMetricsContainer extends Component {

  static propTypes = {
    chartData: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    deviceName: PropTypes.string
  };

  render() {
    const metricsObj = this.props.chartData;
    const deviceNames = [];
    const deviceData = new Map();

    if (Object.keys(metricsObj).length === 0)
    {
      return null;
    }

    for (const device in metricsObj) {
      deviceNames.push(device);
      const subdata = metricsObj[device];
      deviceData.set(device, subdata);
    }

    return (
      <div>
        <AcquisitionMetricsSelectorComponent
          deviceNames = {deviceNames}
          onSubmit = {this.props.onSubmit}
        />

        <AcquisitionLineChartComponent
          deviceData = {deviceData}
          deviceName = {this.props.deviceName}
        />
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: deviceName => {
    dispatch(setDevice(deviceName));
  }
});

export const mapStateToProps = (state) => {
  const deviceName = getDeviceName(state);
  return { deviceName: deviceName };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcquisitionMetricsContainer);



// WEBPACK FOOTER //
// src/Containers/AcquisitionMetricsContainer.jsx